<template>
  <Teleport to="body">
    <component
      v-for="m in modals"
      :key="m.id"
      :is="getModalComp(m.type)"
      :ctx="m.payload"
      v-bind="m.payload"
      v-model:open="m.open"
      :pending="m.pending ?? getPendingState(m)"
      :modal-id="m.id"
      :state="m.uiState ?? getModalState(m)"
      :can-retry="canRetry(m)"
      :retry-count="m.retryCount ?? getRetryCount(m)"
      :error="m.error ?? getError(m)"
      @confirm="(data: unknown) => handleConfirm(m.id, data)"
      @cancel="(reason: unknown) => handleCancel(m.id, reason)"
      @retry="() => handleRetry(m.id)"
      @force-close="() => handleForceClose(m.id)"
    />
  </Teleport>
</template>

<script setup lang="ts">
import { Teleport } from 'vue'
import { storeToRefs } from 'pinia'
import { useModalManagerStore, getModalComp } from '@/store/modalManager/modalManager'

const modalStore = useModalManagerStore()
const { modals } = storeToRefs(modalStore)

// 获取弹窗的pending状态
function getPendingState(modal: any): boolean {
  const snapshot = modal.actor.getSnapshot()
  return snapshot.value === 'processing'
}

// 获取弹窗状态
function getModalState(modal: any): string {
  const snapshot = modal.actor.getSnapshot()
  return snapshot.value
}

// 检查是否可以重试
function canRetry(modal: any): boolean {
  const snapshot = modal.actor.getSnapshot()
  return snapshot.value === 'error' && snapshot.context.retryCount < snapshot.context.maxRetries
}

// 获取重试次数
function getRetryCount(modal: any): number {
  const snapshot = modal.actor.getSnapshot()
  return snapshot.context.retryCount || 0
}

// 获取错误信息
function getError(modal: any): any {
  const snapshot = modal.actor.getSnapshot()
  return snapshot.context.error
}

// 处理确认事件
function handleConfirm(modalId: string, data: unknown): void {
  modalStore.confirm(modalId, data)
}

// 处理取消事件
function handleCancel(modalId: string, reason: unknown): void {
  modalStore.cancel(modalId, String(reason || 'user_cancel'))
}

// 处理重试事件
function handleRetry(modalId: string): void {
  modalStore.retry(modalId)
}

// 处理强制关闭事件
function handleForceClose(modalId: string): void {
  modalStore.forceClose(modalId)
}
</script>
